// The admin part of the CRM app (R-U29–R-U32): deals and tasks live in pipelines — «Мои», «Все» with branches, a page per pipeline
// (a category of tasks is one too). The app gives its words and fields; the core draws the column and the pages.

import { registerPipelineSection } from '@confdeck/core-web';

/** What the CRM app adds to the admin shell. The product's web entry calls it — the shell knows nothing about the types of the apps. */
export function setupCrmWeb() {
  registerPipelineSection({
    typeKey: 'deal',
    words: { mine: 'Мои сделки', all: 'Все сделки', create: 'Новая воронка', pipeline: 'Воронка', pipelineAcc: 'воронку' },
    mine: 'ownerId', due: 'next_action',
    card: ['stage:pipeline', 'stage', 'amount', 'company'],
    list: ['stage:pipeline', 'stage', 'amount', 'company', 'next_action', 'ownerId'],
    bulk: [{ kind: 'stage', label: 'Сменить этап' }, { kind: 'owner', label: 'Сменить ответственного' }, { kind: 'due', label: 'Перенести дату' }],
    followUp: { label: 'Задача', typeKey: 'task', person: 'assignee', due: 'due', link: 'deal' },
  });
  registerPipelineSection({
    typeKey: 'task',
    words: { mine: 'Мои задачи', all: 'Все задачи', create: 'Новая категория', pipeline: 'Категория', pipelineAcc: 'категорию' },
    mine: 'assignee', due: 'due',
    card: ['status:pipeline', 'status', 'deal'],
    list: ['status:pipeline', 'status', 'due', 'deal', 'contact'],
    branches: [
      { key: 'todo', label: 'К выполнению', kind: 'start' }, { key: 'doing', label: 'В работе', kind: 'work' },
      { key: 'done', label: 'Готово', kind: 'won' }, { key: 'cancelled', label: 'Отменена', kind: 'lost' },
      { key: 'overdue', label: 'Просроченные', kind: 'overdue' }, { key: 'unassigned', label: 'Без исполнителя', kind: 'unassigned' },
    ],
    bulk: [{ kind: 'won', label: 'Выполнить' }, { kind: 'owner', label: 'Переназначить' }, { kind: 'due', label: 'Перенести' }],
  });
}
